import type { RequiredOAISchema } from '~/types/openapi';

export const personalData = (
  user: RequiredOAISchema<'MarketBuyerResponse'> | undefined,
) => {
  if (user === undefined) return undefined;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { phoneNumber, name, addresses, ...userInfo } = user;

  return userInfo;
};
